import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  isMobileDevice(): boolean {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    const viewportIsSmall = window.matchMedia('(max-width: 768px)').matches;
    const userAgent = navigator.userAgent || navigator.vendor || '';
    const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isMobileAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent
    );

    return viewportIsSmall || (hasTouchSupport && isMobileAgent);
  }

  isViewportWidthBelow(breakpoint = 991): boolean {
    if (typeof window === 'undefined') {
      return this.isMobileDevice();
    }

    return window.innerWidth <= breakpoint;
  }
}
